<template>
	<div 
		class="case-overview-row"
		:class="[
			thisCase.status == 'archive' ? 'archive' : false
		]"
		>

		<div class="progress-row">
			<div 
				v-for="(stage, index) in stages"
				:key="index"
				class="progress-column"
				:class="[
					`stage-${processSteps[index]}`
				]"
				/>
		</div>

		<div class="progress-status-simple">
			<template 
				v-for="(stage, index) in stages"
				:key="index"
				>
				<div
					v-if="['current', 'done'].includes(processSteps[index])"
					class="simple-progress-box"
					:class="[
						`stage-${processSteps[index]}`
					]"
					>
					<i class="fal fa-check" v-if="processSteps[index] == 'done'" />
					<div class="title">
						{{ stage }}
					</div>
				</div>
			</template>
		</div>

		<div 
			class="case-info"
			:class="[ 
				(assignTeam && canEditCase) || (assignManager && canEditCase) ? 'with-admin-options' : false,
			]"
			>

			<div class="case-details-columns">
				<div class="case-owner case-detail">
					<span>Surgeon:</span> {{ thisCase.user.name }}
				</div>

				<div class="case-manager case-detail">
					<span>Rep:</span> {{ thisCase.manager != null ? thisCase.manager.name : 'n/a' }}
					<div
						class="mini-button" 
						v-if="thisCase.status != 'archive' && assignManager && canEditCase && allPotentialManagers" 
						@click="toggleShowManagerSelector"
						>
						{{ thisCase.manager != null ? 'Change' : 'Set' }}
					</div>
				</div>

				<div class="case-team case-detail">
					<span>Distributor:</span> {{ activeTeam != false ? activeTeam.name : 'n/a' }}
					<div
						class="mini-button" 
						v-if="thisCase.status != 'archive' && assignTeam && canEditCase" 
						@click="toggleShowTeamSelector">
						{{ activeTeam != false ? 'Change' : 'Set' }}
					</div>
				</div>
			</div>

			<div class="case-specifics">
				<div class="case-id">
					Case #{{ visibleCaseID }}
				</div>

				<div class="case-desc">
					<span 
						v-if="thisCase.status == 'archive'"
						class="archive-tag"
						>
						<i class="fal fa-archive" /> Archived
					</span>
	
					{{ description }}
				</div>

				<div class="case-small-details">
					<div>
						<strong>Status:</strong> {{ thisCase.status }}
					</div>
					<div>
						<strong>Created:</strong> {{ formatDate(thisCase.created_at) }}
					</div>
					<div>
						<strong>Updated:</strong> {{ formatDate(thisCase.updated_at) }}
					</div>
				</div>
			</div>
			
			<div class="case-meta">
				<div 
					v-if="userAssignedAs"
					class="case-meta-inner"
					>
					<div class="assigned-as">
						{{ userAssignedAs }}
					</div>
				</div>

				<div class="case-meta-inner">
					<div class="case-data">
						<div 
							class="viewers"
							v-if="['admin'].includes($page.props.user.user_type)"
							>
							<i class="fal fa-eye" />
							{{ thisCase.viewers.length }}
						</div>
						<div 
							class="editors"
							v-if="['admin'].includes($page.props.user.user_type)"
							>
							<i class="fal fa-user-edit" />
							{{ thisCase.editors.length }}
						</div>
						
						<div class="bubble">
							{{ commentCount }}
						</div>
					</div>

					<Link :href="`/cases/${caseID}`">
						<Button
							class="select-option-button"
							size="small"
							color="black"
							label="View Case"
							icon="chevron-right"
							/>
					</Link>

				</div>
			</div>
		</div>

		<!--
		<Link :href="['admin','team_admin'].includes($page.props.user.user_type) ? `/admin/cases/${caseID}` : `/cases/${caseID}`">
			<div 
				class="link-overlay" 
				:class="[ assignTeam || assignManager ? 'with-admin-options' : false ]" 
				/>
		</Link>
		-->

		<div 
			v-if="assignTeam && canEditCase"
			class="select-option-modal select-team-modal"
			:class="[ showTeamSelector ? 'active' : null ]"
			>
			<div class="dark-overlay" @click="toggleShowTeamSelector"></div>
			<div class="select-options-container">
				<Subtitle
					:title="team.length == 0 ? 'Assign Distributor' : 'Reassign Distributor'"
					:subtext="team.length == 0 ? 'Assign this case to another distributor' : 'Reassign this case to another distributor'"
					/>

				<ul class="option-list">
					<li 
						v-for="(t, index) in teams" 
						:key="index"
						:class="[t.id == activeTeam.id ? 'active' : null]"
						>
						{{ t.name }}

						<div 
							class="current-option"
							v-if="t.id == activeTeam.id"
							>
							Current Distributor
						</div>

						<Button
							v-if="t.id != activeTeam.id"
							class="select-option-button"
							size="small"
							color="white"
							icon="hand-pointer"
							label="Select this distributor"
							@click="assignToTeam(caseID, t.id)"
							/>
					</li>
				</ul>

				<Button
					@click="toggleShowTeamSelector"
					class="cancel-button"
					size="regular"
					color="white"
					icon="times"
					label="Cancel"
					/>

			</div>
		</div>


		<div 
			v-if="assignManager && canEditCase && allPotentialManagers"
			class="select-option-modal select-manager-modal"
			:class="[ showManagerSelector ? 'active' : null ]"
			>
			<div class="dark-overlay" @click="toggleShowManagerSelector"></div>
			<div class="select-options-container">
				<Subtitle
					:title="!thisCase.manager ? 'Assign Rep' : 'Reassign Rep'"
					subtext="When a rep is assigned, only that rep and the user assigned to the Case will receive any notifications. If no rep is assigned then notifications will be sent to the user as well as every Meshworks Admin and Distributor Admin on the same team."
					/>

				<MultiSelect
					v-model="selectedManager"
					:options="reformatPotentialManagers"
					:singleSelectionOnly="true"
					:showSelectedList="false"
					:enableSearch="true"
					:holdSelection="thisCase.manager != null ? thisCase.manager.id : false"
					holdSelectionLabel="Current Rep"
					:showUpdateButton="true"
					@updateRequested="assignManagerToCase(caseID, selectedManager)"
					/>
				

				<div class="button-row">
					<Button
						@click="toggleShowManagerSelector"
						class="cancel-button"
						size="regular"
						color="white"
						icon="times"
						label="Cancel"
						/>
					<Button
						v-if="thisCase.manager != null"
						@click="removeManager(caseID)"
						class="remove-manager"
						size="regular"
						color="red"
						icon="ban"
						label="Remove Rep"
						/>
				</div>

			</div>
		</div>

	</div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3'
import Button from "@/Components/Button"
import Subtitle from "@/Components/Subtitle"
import MultiSelect from '@/Components/MultiSelect.vue'

import moment from 'moment'

export default {
	components: {
		Link,
		Button,
		Subtitle,
		MultiSelect
	},
	props: [
		'steps', // starts at 0 goes to 6
		'caseID',
		'visibleCaseID',
		'description',
		'commentCount',
		'thisCase',
		'assignTeam',
		'assignManager',
		'teams',
		'team',
		'allPotentialManagers',
		'permissions'
	],
	data: () => {
		return {
			stages: [
				'Enquiry Submission',
				'Image Submission',
				'Design Meeting',
				'Treatment Plan',
				'Implant Production',
				'Post Market Surveillance'
			],
			showTeamSelector: false,
			showManagerSelector: false,
			selectedManager: [],
		}
	},
	mounted(){
		// console.log('thisCase', this.thisCase)

		if(this.thisCase.manager != null && this.thisCase.manager.id){
			this.selectedManager = [this.thisCase.manager.id]
		}
	},
	methods: {
		isInPast(inputDate, inputTime){
      if(inputDate != null){
        let d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear(),
          hours = d.getHours(),
          minutes = d.getMinutes();

        hours = ("0" + hours).slice(-2);
        minutes = ("0" + minutes).slice(-2);
        day = ("0" + day).slice(-2);
        month = ("0" + month).slice(-2);

        let splitDate = inputDate.split('-').join('')
        let splitTime = inputTime.split(':').join('')

        if(parseInt(splitDate + splitTime) <= parseInt(String(year)+String(month)+String(day) + String(hours)+String(minutes))){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
		toggleShowTeamSelector(){
			this.showTeamSelector = !this.showTeamSelector
		},
		assignToTeam(caseID, teamID){
			this.$inertia.post(`/admin/cases/${caseID}/set-team`, {
				team: teamID,
			})
			this.toggleShowTeamSelector()
		},
		toggleShowManagerSelector(){
			this.showManagerSelector = !this.showManagerSelector
		},
		assignManagerToCase(caseID, managerID){
			this.$inertia.post(`/admin/cases/${caseID}/set-manager`, {
				manager: managerID,
			})
			this.toggleShowManagerSelector()
		},
		removeManager(caseID){
			this.$inertia.post(`/admin/cases/${caseID}/set-manager`, {
				manager: false,
			})
			this.toggleShowManagerSelector()
			this.selectedManager = []
		},
		formatDate(date){
			return moment(date).format('DD/MM/YYYY HH:mm')
		},
	},
	computed: {
		userAssignedAs(){
			if(['team_user', 'user', 'viewer'].includes(this.$page.props.user.user_type)){
				let assignments = []

				if(this.thisCase.user.id == this.$page.props.user.id){
					assignments.push('Surgeon')
				}
				if(this.thisCase.manager && this.thisCase.manager.id == this.$page.props.user.id){
					assignments.push('Rep')
				}
				if(this.thisCase.editors.some(editor => editor.id === this.$page.props.user.id)){
					assignments.push('Editor')
				}
				if(this.thisCase.viewers.some(viewer => viewer.id === this.$page.props.user.id)){
					assignments.push('Viewer')
				}

				if(assignments.length == 0){
					return false
				}

				// if there are just two assignments then use an ampersand, otherwise use commas
				let assignmentList = ''
				if(assignments.length == 2){
					assignmentList = assignments.join(' & ')
				}else{
					assignmentList = assignments.join(', ')
				}
				
				// if the first letter in assignmentList is a vowel minus 'u'
				if(assignments.length == 1 && assignments[0] == 'Surgeon'){
					return `You are the ${assignmentList}`
				}else if(['a','e','i','o'].includes(assignmentList.charAt(0).toLowerCase())){
					return `You are an ${assignmentList}`
				}else{
					return `You are a ${assignmentList}`
				}
			}else{
				return false
			}
		},
		reformatPotentialManagers(){
			if(this.allPotentialManagers){
				return this.allPotentialManagers.map(manager => {
					return {
						id: manager.id,
						name: manager.name + ' (' + manager.email + ')'
					}
				})
			}else{
				return []
			}
		},
		canEditCase(){
			if(this.$page.props.user.id == this.thisCase.user_id // if owner
				|| ['admin'].includes(this.$page.props.user.user_type) // if admin
				|| (['team_admin'].includes(this.$page.props.user.user_type) && this.$page.props.user.teams.length > 0 && this.thisCase.teams.length > 0 && this.thisCase.teams[0].id == this.$page.props.user.teams[0].id) // if team admin and team admin is on the same team as the case
				|| this.thisCase.manager && this.thisCase.manager.id == this.$page.props.user.id // if manager
				){
				return true
			}else{
				return false
			}
		},
		activeTeam(){
			if(this.team){
				if(this.team.length > 0){
					for(let theTeam of this.team){
						return theTeam
					}
				}else{
					return false
				}
			}else{
				return false
			}
		},
		processSteps(){

			let output = []

			switch(parseInt(this.steps)){
				case 0:
					output = ['current','todo','todo','todo','todo','todo']
					break;
				case 1:
					output = ['done','current','todo','todo','todo','todo']
					break;
				case 2:
					output = ['done','done','current','todo','todo','todo']
					break;
				case 3:
					if(this.thisCase){
						if(this.thisCase.override_progress >= 3){
							output = ['done','done','done','current','todo','todo']
						}else{
							if(this.thisCase.treatment_plan_deadline != null){
								output = ['done','done','done','current','todo','todo']
							}else{
								output = ['done','done','done','todo','todo','todo']
							}
						}
					}else{
						output = ['done','done','done','current','todo','todo']
					}
					break;
				case 4:
					if(this.isInPast(this.thisCase.implant_production_date, '00:00')){
						output = ['done','done','done','done','done','todo']
					}else{
						output = ['done','done','done','done','current','todo']
					}
					break;
				case 5:
					let implantProductionDone = false
					if(this.thisCase != null && this.isInPast(this.thisCase.implant_production_date, '00:00')){
						implantProductionDone = true
					}

					output = ['done','done','done','done',(implantProductionDone ? 'done' : 'current'),(implantProductionDone ? 'current' : 'pending')]

					break;
				case 6:
					output = ['done','done','done','done','done','current']
					break;
			}

			

			return output
		}
	}
}
</script>

<style scoped lang="sass">

.case-overview-row
	width: 100%
	min-height: 110px
	height: auto
	border-radius: 8px
	box-shadow: 0 1px 3px rgba(#000, 0.2)
	background-color: #fff
	overflow: hidden
	position: relative

	&.archive
		filter: grayscale(80%)

	.progress-status-simple
		display: block

		.simple-progress-box
			height: 30px
			padding: 0 10px
			align-items: center
			font-family: 'Roboto Condensed', sans-serif
			font-size: 12px
			color: #252525
			font-weight: 400
			line-height: 1.2
			gap: 10px
			display: none

			&:before
				content: ''
				width: 8px
				height: 8px
				border-radius: 50%

			&.stage-current
				background-color: rgba(#70c2ff, 0.1)

				&:before
					background-color: #70c2ff

			&.stage-done
				background-color: rgba(#5aae4b, 0.2)

				.fal
					color: #5aae4b
					font-weight: 700

				&:before
					display: none

			&:last-of-type
				display: flex

			
				


	.case-info
		display: grid
		grid-template-columns: 1fr 0.8fr
		// align-items: center

		@media (max-width: 1024px)
			display: flex
			flex-direction: column


		.case-specifics
			display: flex
			flex-direction: column
			// gap: 5px
			width: 100%

			@media (max-width: 1024px)
				order: 1

			.case-id
				font-family: 'Roboto Condensed', sans-serif
				font-size: 21px
				color: #252525
				font-weight: 700
				line-height: 1.2
				padding: 12px 20px 0px

			.case-desc
				font-family: 'Roboto', sans-serif
				font-size: 16px
				color: #838383
				font-weight: 400
				line-height: 1.2
				width: 100%
				padding: 0 20px 10px

				.archive-tag
					display: inline-flex
					align-items: center
					gap: 5px
					font-size: 14px
					font-weight: 700
					color: #fff
					background-color: #888
					padding: 5px 10px
					border-radius: 10px
					margin-right: 10px

					.fal
						font-size: 14px

			.case-small-details
				display: flex
				gap: 10px
				padding: 0 20px 15px
				font-size: 12px
				color: #7c7c7c
				text-transform: capitalize


		.case-details-columns
			display: grid
			grid-template-columns: repeat(3, 1fr)
			grid-column: span 2

			@media (max-width: 1024px)
				order: 2
				display: flex
				flex-direction: column
				border-top: 1px solid rgba(#000, 0.1)


			.mini-button
				display: flex
				position: relative
				cursor: pointer
				border-radius: 3px
				padding: 3px 6px
				border: 1px solid #00ff11
				font-size: 10px
				background-color: #dcffda
				line-height: 1
				font-weight: 700
				color: #007c00

			.case-detail
				font-weight: 400
				display: flex
				font-size: 13px
				gap: 8px
				padding: 6px 20px
				border-bottom: 1px solid rgba(#000, 0.1)
				border-right: 1px solid rgba(#000, 0.1)
				
				&:last-of-type
					border-right: none

				@media (max-width: 1024px)
					border-right: none

				span
					font-weight: 700


		.case-meta
			display: flex
			justify-content: space-between
			padding: 20px
			flex-direction: column
			align-items: flex-end
			justify-content: flex-end
			gap: 15px

			@media (max-width: 1024px)
				display: block
				order: 3
				width: 100%

			.case-meta-inner
				display: flex
				align-items: center
				justify-content: flex-end
				gap: 15px

				.assigned-as
					font-size: 11px
					padding: 4px 6px
					border-radius: 3px
					background-color: rgba(#000, 0.1)
					color: #333
					font-weight: 700
					line-height: 1

				@media (max-width: 1024px)
					justify-content: space-between

					.assigned-as
						margin-bottom: 5px

			.case-data
				display: flex
				gap: 15px

				.viewers
					display: flex
					gap: 5px
					align-items: center
					font-size: 13px
					height: 24px

					.fal
						opacity: 0.7
						font-size: 16px

				.editors
					display: flex
					gap: 5px
					align-items: center
					font-size: 13px
					height: 24px

					.fal
						opacity: 0.7
						font-size: 16px

			.bubble
				background-color: #575757
				border-radius: 4px
				height: 24px
				width: 28px
				font-family: 'Roboto', sans-serif
				font-size: 12px
				color: #fff
				display: flex
				align-items: center
				justify-content: center
				position: relative

				&:before
					content: ''
					position: absolute
					background-color: #575757
					width: 5px
					height: 6px
					bottom: -2px
					left: 6px
					transform: skewY(-40deg)



	.progress-row
		display: grid
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr
		grid-column-gap: 1px

		.progress-column
			height: 40px
			padding: 0 22px
			align-items: center
			position: relative
			display: flex
			justify-content: space-between
			height: 10px

			&:after
				content: ''
				height: 3px
				position: absolute
				bottom: 0
				left: 0
				right: 0

			&.stage-done
				background-color: rgba(#5aae4b, 0.3)

				&:after
					background-color: #5aae4b

			&.stage-scheduled
				background-color: rgba(#fff, 0.3)

				&:after
					background-color: #5aae4b

			&.stage-current
				background-color: rgba(#70c2ff, 0.3)

				&:after
					background-color: #70c2ff

			&.stage-todo
				background-color: rgba(#edc7b7, 0.3)

				&:after
					background-color: #edc7b7

			&.stage-pending
				background-color: rgba(#edc7b7, 0.3)

				&:after
					background-color: #edc7b7


	.link-overlay
		position: absolute
		top: 0
		left: 0
		right: 0
		bottom: 0
		cursor: pointer
		transition: all 300ms

		&:hover
			background-color: rgba(#000, 0.05)

		&.with-admin-options
			right: 50%

			&:hover
				background-color: transparent

	.select-option-modal
		position: fixed
		z-index: 100
		top: 0
		left: 0
		right: 0
		bottom: 0
		display: flex
		align-items: center
		justify-content: center
		visibility: hidden
		opacity: 0
		transition: all 300ms

		.dark-overlay
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0
			background-color: rgba(#000, 0.5)
			z-index: 1

		.select-options-container
			min-height: 200px
			width: 100%
			max-width: 600px
			margin: 25px
			border-radius: 10px
			box-shadow: 0 0 20px rgba(#000, 0.3)
			background-color: #f9f9f9
			z-index: 2
			position: relative
			display: flex
			opacity: 0
			transform: translateY(30px)
			transition: all 300ms
			padding: 25px 30px
			flex-direction: column

			.button-row
				display: flex
				align-items: center
				justify-content: space-between
				padding-top: 15px

			.option-list
				margin-bottom: 20px
				overflow: auto
				max-height: 70vh

				li
					padding: 8px
					border-bottom: 1px solid rgba(#000, 0.15)
					font-weight: 700
					display: flex
					justify-content: space-between
					align-items: center

					&.active
						background-color: rgba(#000, 0.05)
						cursor: not-allowed

					.current-option
						color: #d00

					&:last-child
						border-bottom: none

		&.active
			opacity: 1
			visibility: visible

			.select-options-container
				opacity: 1
				transform: translateY(0)
</style>
